/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconPackage, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { PackagingType } from '../../../models/core/packaging.type';
import packagingsService from '../../../services/core/packaging.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: PackagingType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function PackagingPicker(props: FormViewProps) {
  const [data, setData] = useState<PackagingType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: PackagingType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await packagingsService.list();
      setData(result);
      sessionStorage.setItem(`${SessionStorageKey.PackagingSearch}`, JSON.stringify(result));
    } catch (error: any) {
      showNotification({
        title: `Acondicionamentos`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível listar os acondicionamentos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(`${SessionStorageKey.PackagingSearch}`) || '[]'
      ) as PackagingType[];

      if (cacheResult.length > 0) {
        setData(cacheResult);
      } else {
        loadData();
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idResiduoAcondicionamento}|${x.residuoAcondicionamento}|${x.descricao}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idResiduoAcondicionamento?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`packaging-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconPackage size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idResiduoAcondicionamento} - ${x.residuoAcondicionamento}`,
              value: x.idResiduoAcondicionamento.toString(),
              disabled: props.idsToBeDisabled.includes(x.idResiduoAcondicionamento),
              group: x.residuoAcondicionamento.toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idResiduoAcondicionamento.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idResiduoAcondicionamento.toString()}
              name={row.residuoAcondicionamento}
              nameSize="sm"
              description={row.descricao}
              descriptionSize="xs"
              linkPrefix="packagings"
              showLink={false}
            />
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(
            data.find((x) => x.idResiduoAcondicionamento.toString() === value) || null,
            true
          );
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
